$(document).ready(function() {
    $('#contact-us-form').find('#how-hear').change(function(event) {
        if ($(this).val() === 'Other' || $(this).val() === 'Industry Association' || $(this).val() === 'Client Referral') {
            $('#contact-us-form').find('#how-hear-other-div').removeClass('hidden');
        } else {
            $('#contact-us-form').find('#how-hear-other-div').addClass('hidden');
        }
    });

    function syncTravelPlansVisibility() {
        var $form = $('#contact-us-form');
        if ($form.find('#iknowmytravelplans').prop('checked')) {
            $form.find('#quote-fields').removeClass('hidden');
            $form.find('#group-name').attr('required', true);
            $form.find('#group-number').attr('required', true);
        } else {
            $form.find('#quote-fields').addClass('hidden');
            $form.find('#trip-comments').val('');
            $form.find('#group-name').attr('required', false);
            $form.find('#group-number').attr('required', false);
        }
    }

    $('#contact-us-form').find('#iknowmytravelplans').change(syncTravelPlansVisibility);

    // Sync after browser restores form state (load fires after form restoration,
    // pageshow handles bfcache back/forward navigation)
    $(window).on('load pageshow', function() {
        syncTravelPlansVisibility();
    });

    //process the request an invite form.
    $('#contact-us-form').submit(function(event) {
        // stop the form from submitting the normal way and refreshing the page
        event.preventDefault();
        //disable the button.
        $('#contact-button').removeClass('btn-cta-primary').html('Please Wait...').attr('disabled', true);
        let formData = $(this).serializeArray();

        // trim all inputs
        formData = formData.map(function(input){
            input.value = input.value.trim();
            return input;
        });

        // convert to string
        formData = $.param(formData);

        // process the form
        $.ajax({
            type        : 'POST',
            url         : '/contact-us',
            data        : formData
        }).success(function(data) {
            $('#contact-success').show();
            $('#contact-failed').hide();
            $('#contact-us-form').hide();

        }).error(function(data){
            grecaptcha.reset(contactRecaptcha);
            $('#contact-failed').show();
            $('#contact-button').addClass('btn-cta-primary').html('Submit Request').attr('disabled', false);
        });
    });
});
